
<template>
  <div class="discussion" ref="discussion">
    <div class="online-wrapper" v-show="onlineNum!=0">{{onlineNum}}人正在观看</div>
    <div class="discuss-wrapper" v-for="(item, key) in discussion" :key="key">
      <span class="level-wrapper">{{ item.level}}</span>
      <span class="sender">{{ item.sender }}</span>
      <span v-if="item.sender">:</span>
      <span class="discussion-content">
        {{
        item.content
        }}
      </span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    discussion: {
      type: Array,
      default: () => []
    },
    onlineNum: {
      type: Number,
      default: 0
    }
  },
  watch: {
    discussion: {
      handler() {
        this.$nextTick(() => {
          //收到新消息时滚动到底部
          this.$refs.discussion.scrollTop = this.$refs.discussion.scrollHeight;
        });
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.discussion {
  position: relative;
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
  overflow: auto;
  text-align: left;
  background: #f5f5f5;
}
.discuss-wrapper {
  line-height: 1.5;
}
.level-wrapper {
  display: inline-block;
  height: 20px;
  min-width: 18px;
  margin-right: 8px;
  padding: 0 4px 0 30px;
  vertical-align: middle;
  background: url("~@/assets/icon_level_start.png") no-repeat 10px 50%;
  background-size: 16px;
  background-color: #56e1ff;
  border-radius: 4px;
  line-height: 20px;
  color: #fff;
  font-size: 12px;
  text-align: center;
}
.discussion-content {
  font-size: 14px;
  color: #333;
}
.sender {
  color: #999;
  font-size: 14px;
}
.online-wrapper {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0 4px 0 8px;
  line-height: 0.5rem;
  background: rgba(0, 0, 0, 0.2);
  color: #ffffff;
  font-size: 14px;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
</style>